export default "__VITE_ASSET__CwJwxUy0__"